export const resetOrderForm = () => {
    localStorage.removeItem('order_form')
}